/// <reference path="../../../node_modules/@types/jquery/index.d.ts" />
var CaseStudyArchiveButton = /** @class */ (function () {
    function CaseStudyArchiveButton() {
        this.archivedCaseStudiesAreShowing = false;
        this.archivedCaseStudiesHTML = '';
        var that = this;
        $('#caseStudyArchiveButton').on('click', function () {
            if (that.archivedCaseStudiesAreShowing === false) { // show the archived case studies
                that.archivedCaseStudiesAreShowing = true;
                $(this).text('HIDE ADDITIONAL CASE STUDIES');
                // if the content hasn't been fetched before, then store it too
                if (that.archivedCaseStudiesHTML === '') {
                    $("#caseStudyArchives").load("/case-studies/archived-case-studies.aspx", function (data) {
                        that.archivedCaseStudiesHTML = data;
                    });
                }
                else {
                    $("#caseStudyArchives").html(that.archivedCaseStudiesHTML);
                }
            }
            else { // hide the archived case studies
                that.archivedCaseStudiesAreShowing = false;
                $(this).text('VIEW MORE CASE STUDIES');
                $("#caseStudyArchives").html("");
            }
        });
    }
    return CaseStudyArchiveButton;
}());

/// <reference path="../../../node_modules/@types/jquery/index.d.ts" />
$(document).ready(function () {
    var caseStudyArchiveButton = new CaseStudyArchiveButton();
});
